import { links, contactEmail } from 'settings';

export const FooterComponent = () => {
	return (
		<>
			<div className="footer-block foote-block-links">
				<div className="footer-block-part text-left">
					<a className="footer-block-item" href={ links.footer.forBlogers }>Блогерам и консультантам</a>
					<a className="footer-block-item" href={ links.footer.forAds }>Реклама</a>
					<a className="footer-block-item" href={ links.footer.forPartners }>Партнеры</a>
					<a className="footer-block-item" href='/donation'>Помощь проекту</a>
				</div>
				<div className="footer-block-part text-right">
					<a className="footer-block-item" href={ links.footer.termsOfUse }>Пользовательское соглашение</a>
					<a className="footer-block-item" href={ links.footer.foundErrors }>Нашли ошибку?</a>
				</div>
			</div>
			<div className="footer-divider"></div>
			<div className="footer-block footer-block-info">
				<div className="footer-block-part text-left">
					<p>
						<b>RusEtfs</b> - свободная база данных о биржевых паевых инвестиционных фондах для инвесторов от инвесторов.
					</p>
				</div>
				<div className="footer-block-part text-right">
					<p>
						E-mail: <a href={`mailto:${contactEmail}`}>{ contactEmail }</a>
						<br />
						2019-{new Date().getFullYear()} RusEtfs™
					</p>
				</div>
			</div>
		</>
	);
}